<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202306_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202306_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left">美容の新習慣<br class="only_sp">「インバスケア」で<br class="only_sp">保湿革命</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <div class="feature-row mt-5 pt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202306_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <p class="mb-3">日本人は世界でも類を見ないほど、お風呂好きと言われています。</p>
        <p class="mb-3">実は、日本のお風呂は温泉→銭湯→家風呂と変遷してきました。</p>
        <p class="mb-3">入浴という習慣は、もともとは仏教の「身を清める」が始まりと言われています。</p>
        <p class="mb-3">ところが近隣のアジア諸国でお家にお風呂がある国はありません。</p>
        <p>日本の家風呂は世界でも珍しい独特の文化なんです。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <p class="mb-3">マナビスは、この日本独自の文化とも言える「家風呂」にフォーカスしました。</p>
        <p class="mb-3">浴槽があるお風呂では、入浴によって、血流が良くなること、リラックスできることなど、様々なメリットがあります。</p>
        <p>これは、お肌のターンオーバーを促すなど、お肌にとっても「とても嬉しい時間」なんです。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202306_03.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202306_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <p class="mb-3">ただ、忘れてはいけないことは、入浴後の肌のことです。</p>
        <p class="mb-3">お肌が喜ぶ環境である入浴中と、入浴後では温度や湿度など大きな違いがあります。</p>
        <p>お風呂を上がった後のお肌は、急激な乾燥と戦うことになります。</p>
      </div>
    </div>
    <div>
      <img src="@/assets/img/column/202306_05.jpg">
    </div>
    <h2 class="mt-5 pt-5">マナビスはこの部分に着目。<br>毎日のスキンケアを万全にするためにも、<br>お風呂で十分なスキンケアを行うべきだと考えました。</h2>
    <div class="layer_03  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_03.jpg">
      <div class="layer-text">
        <h3 class="mb-3">入浴後のお肌の<br class="only_sp">「保湿リミット」<br>理想は10分以内です。</h3>
        <p class="mb-3"><img src="@/assets/img/column/202306_06.jpg" class="d-inline-block"></p>
        <p class="mb-3">お風呂へ入ることは、肌を清潔に保ち、美容やスキンケアにとって大切な時間です。</p>
        <p class="mb-3">身体が芯から温まることで、血流が良くなり、お肌のターンオーバーを活性化。</p>
        <p class="mb-3">毛穴が開くことで、スキンケアアイテムもお肌に浸透しやすくなり、様々な美容効果が期待できます。</p>
        <p class="mb-3">しかし、ここでとても重要なのは「入浴直後の乾燥」対策です。</p>
        <p class="mb-3">入浴後はお肌の水分量が増加し、潤っていると感じますが、これは一時的なもの。実はとても乾燥しやすい状態で、柔らかくなっているお肌はデリケート。</p>
        <p class="mb-3">入浴後、すぐに保湿をしてあげないと、急激なスピードで乾燥がはじまり、お肌は「過乾燥状態」に陥ります。</p>
        <p class="mb-3">なんと、入浴前の状態よりも水分量が低くなることが、研究結果でもわかっています。</p>
        <p class="mb-3">入浴後の乾燥が始まるお肌を、保湿ケアするべき時間は「保湿リミット」と呼ばれています。</p>
        <p>その時間は、一般的に「10分以内」が推奨といわれています。</p>
      </div>
    </div>
    <h2 class="mb-5 pt-5">知ってほしい、保湿革命「インバスケア」</h2>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">「保湿ケア」で、お肌の潤い時間を持続的に。</h3>
        <p class="mb-3">同研究結果からも報告されている、入浴直後の水分量の多い状態のお肌にアプローチをする重要性。</p>
        <p>過乾燥が始まる前に、お風呂の中で「保湿ケア」をすることで、お肌が水分量持続する時間が伸びることがわかっています。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202306_07.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202306_08.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <p class="mb-3">考察として、お肌にとって必要な皮脂や、NMF（天然保湿因子）、各層細胞間脂質といった本来肌に備わっている保湿物質が流出。</p>
        <p class="mb-3">それにより、肌が水分を保持できなくなり、過乾燥の状態になると考えられています。</p>
        <p>お風呂の中で、保湿ケアをすることが、水分の蒸発を効果的に防ぐことにつながり、潤い効果の高い状態を持続できるのです。</p>
      </div>
    </div>
    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <h3>日常のバスタイムを美の習慣へ。<br>明日も自分が、好きなわたしであるために。<br>マナビス化粧品は「インバスケア」を提案します。<br>そのステップはお風呂で使える「洗顔」と「スキンマスク」です。</h3>
      </div>
    </div>
    <h2 class="pt-5 mb-5">お肌と同じアミノ酸で、優しく洗顔</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinwash_202306.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">薬用スキンウォッシュ チューブタイプ（約2ヶ月分）</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">マナビス 薬用スキンウォッシュd</p>
        <p class="mb-3">医薬部外品薬用せっけん 150g</p>
        <p class="mb-3">昼用 夜用</p>
        <p class="mb-3">うるおいはそのままに、<br>やわらかな泡で包むように洗う。</p>
        <p>アミノ酸系弱酸性のジェル状せっけん。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <h3 class="text-left">ご使用方法</h3>
    <div class="feature-row feature-row_step pb-0">
      <div>
        <p class="text-center mb-3">STEP 1</p>
        <p class="mb-3 text-center"><img src="@/assets/img/column/skinwash_step1.jpg"></p>
        <p>洗いたい部分を濡らし、適量（お顔の場合、パール1 粒分程度）をとり、 ぬるま湯を少しずつ加えながら泡立てます。</p>
      </div>
      <div>
        <p class="text-center mb-3">STEP 2</p>
        <p class="mb-3 text-center"><img src="@/assets/img/column/skinwash_step2.jpg"></p>
        <p>泡の弾力で内から外に円を描くようにやさしく洗います。</p>
      </div>
      <div>
        <p class="text-center mb-3">STEP 3</p>
        <p class="mb-3 text-center"><img src="@/assets/img/column/skinwash_step3.jpg"></p>
        <p>その後、ていねいに洗い流してください。</p>
      </div>
    </div>
    <p class="mb-5 pb-5"><small>＊容器に水が入らないようにしてください。入った場合はそのまま放置せず、水を取り除いてください。<br>＊泡立て器や泡立て用のネットをお使いいただくと、手早く濃密な泡を作ることができます。</small></p>
    <h3 class="text-left mb-5 pt-5">特徴</h3>
    <p class="mb-3"><strong>美容効果の高い「グリチルリチン酸ジカリウム」配合</strong></p>
    <p class="mb-5">グリチルリチン酸ジカリウムは肌あれを防ぎ、肌を整えることに期待がで きる成分です。洗い流してしまうアイテムにも贅沢に配合しています。</p>
    <p class="mb-3"><strong>素肌と同じ弱酸性のアミノ酸系洗浄成分</strong></p>
    <p class="mb-5 pb-5">ヤシやサトウキビなどからとれるアミノ酸系弱酸性の洗浄成分が、必要な うるおいを残しながら、汚れや余分な皮脂をしっかり落とします。<br>16 種類 の植物由来成分を配合。良質な泡が顔もからだもやさしく洗い上げ、小さな お子様や年配の方、男女問わずお使いいただけます。</p>
    <h2 class="pt-5 mb-5">お風呂で使える保湿パックで、美肌革命</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinmask_202306.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">薬用スキンマスク チューブタイプ（約2ヶ月分）</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">マナビス 薬用スキンマスク</p>
        <p class="mb-3">医薬部外品パック 120g</p>
        <p class="mb-3">夜用</p>
        <p class="mb-3">洗いたての素肌を包み、<br>うるおし、なめらかにするパック。</p>
        <p>洗い流せる、やわらかなクリーム状。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <h3 class="text-left">ご使用方法</h3>
    <div class="feature-row feature-row_step pb-0">
      <div>
        <p class="text-center mb-3">STEP 1</p>
        <p class="mb-3 text-center"><img src="@/assets/img/column/skinmask_step1.jpg"></p>
        <p>適量（お顔の場合、パール3 粒分程度）を手にとります。</p>
      </div>
      <div>
        <p class="text-center mb-3">STEP 2</p>
        <p class="mb-3 text-center"><img src="@/assets/img/column/skinmask_step2.jpg"></p>
        <p>洗顔後の濡れた肌全体（目の周りと口の周りを除く）にやさしくのばします。</p>
      </div>
      <div>
        <p class="text-center mb-3">STEP 3</p>
        <p class="mb-3 text-center"><img src="@/assets/img/column/skinmask_step3.jpg"></p>
        <p>そのまま3 ～ 5 分おいたあと、水またはぬるま湯でこすらず洗い流して ください。</p>
      </div>
    </div>
    <p class="mb-5 pb-5"><small>＊容器に水が入らないようにしてください。入った場合はそのまま放置せず、水を取り除いてください。</small></p>
    <h3 class="text-left mb-5 pt-5">特徴</h3>
    <p class="mb-3"><strong>美容効果の高い「グリチルリチン酸ジカリウム」と肌を整える「グリコール酸」配合</strong></p>
    <p class="mb-3">4000年以上の歴史がある甘草（カンゾウ）から抽出・精製される「グリチルリチン酸ジカリウム」。肌あれを防ぎ、肌を整えることに期待ができます。</p>
    <p class="mb-3">加えて、エステでも肌を整える施術に用いられる「グリコール酸」を、毎日使っても肌に負担がかからないように絶妙なバランスで配合。</p>
    <p class="mb-5 pb-5">また、19種類の植物由来成分を配合。</p>

    <div class="feature-row pt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-75">
        <p class="mb-3"><strong>天然の保湿成分スクワラン</strong></p>
        <p class="mb-3">深海ザメから得られた成分由来の保湿成分。</p>
        <p>肌なじみが良く角層までの浸透性も高いので、肌のなめらかさとうるおいを保ちます。</p>
      </div>
      <div class="feature-row_item_image w-25 text-center">
        <img src="@/assets/img/column/202306_09.jpg"><br>スクワラン
      </div>
    </div>
    <div class="feature-row pt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-75">
        <p class="mb-3"><strong>毎日のバスタイムを、贅沢なホームエステ時間に。</strong></p>
        <p class="mb-3">毎日のバスタイム。日常だからこそ、自分のお肌向き合う時間にすることが、大切です。</p>
        <p class="mb-3">一般的にはスペシャルケアとされるパックを、日常のベーシックケアに取り入れていていただきたい。</p>
        <p class="mb-3">毎日のお手入れの大切さにこだわる、マナビス化粧品ならではのアイテムです。</p>
        <p class="mb-3">スチーム効果やリラックス効果のあるバスタイムに使用することで、より肌になじみます。</p>
        <p>踵や膝、肘などに使うのもおすす めです。角質をやわらかくしてうるおいを与えることで、肌のターンオーバーをサポートします。</p>
      </div>
      <div class="feature-row_item_image w-25">
        <img src="@/assets/img/column/202306_10.jpg"><br>洗顔後の濡れた肌全体（目の周りと口の 周りを除く）にやさしくのばします。
      </div>
    </div>

    <h2 class="mt-5 pt-5">BASIC シリーズ</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/basic_wash-mask_halfset_202306.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">ウォッシュ＆マスク ハーフサイズセット【 マナビス ウォッシュ＋マスク ハーフサイズセット＋ 泡立てネット】（約1ヶ月分）</div>
              <div class="feature-row_product_price">¥5,940</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/basic_skinwash_tube_202306.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">薬用スキンウォッシュ チューブタイプ（約2ヶ月分）</div>
              <div class="feature-row_product_price">¥5,500</div>
            </div>
        </router-link>
      </div>
    </div>

  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 400px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_03 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_03.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img,.layer_03 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text,.layer_03 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2,.layer_03 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}

.feature-row_voice_list {
  align-items: baseline;
  justify-content: flex-start;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px 5px 50px;
  text-align: center;
}
.feature-row_step {
  align-items: baseline;
}
.feature-row_step div {
  width: 33%;
  padding: 5px 5px 50px;
}
.feature-row_step img {
  width: 250px;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  background: rgba(255,255,255,0.55);
  padding: 0 10px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}
.layer_02 {
  position: relative;
  display: flex;
  align-items: center;
  background-image: url('../../assets/img/column/202307_08.jpg');
  background-size: cover;
  min-height: 640px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 60px; /* テキストと画像の端の間に余白を設定 */
}
.layer_02 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_02 .layer-text .layer-text-inner h2 {
  font-size: 3em;
  color: #7e7e74;
}
@media screen and (max-width: 699px) {
    .img-top-slide_text {
      top: 50px;
      transform: translateX(50%);
      right: 50%;
      width: 185px;
    }
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_step div {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer_02 {
    min-height: 300px;
    padding: 15px;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>